export default "__VITE_ASSET__Bee3OOTB__"